module.exports = __webpack_public_path__ + "static/media/sf-test-10.d6e7742c.mp3";